import {Pipe, PipeTransform} from "@angular/core";
import {DateUtils} from "../_utils/date-utils";

@Pipe({name: 'roundMinutesToHour'})
export class RoundMinutesToHourPipe implements PipeTransform {
  transform(minutes: number): number {
    return DateUtils.roundMinutesToHour(minutes);
  }
}
